import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.sort.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import utils from '@/utils';
import dict from './crud-dict';
import pagination from './crud-pagination';
import permission from './crud-permission';
import { request } from '@/api/service';
export default {
  mixins: [dict, pagination, permission],
  provide: function provide() {
    return {
      search: this.search
    };
  },
  data: function data() {
    return {
      // 主体表格
      table: {
        data: [],
        columns: [],
        rowClassName: this.tableRowClassName
      },
      // 搜索
      search: {
        panel: {
          active: true
        },
        form: {
          model: {},
          inline: true,
          labelPosition: 'top'
        }
      },
      // 主体表格列过滤
      columnsFilter: {
        options: []
      },
      // 页面状态
      status: {
        isLoadingData: false,
        isLoadingDict: false
      },
      // 排序
      sort: {
        prop: '',
        type: ''
      }
    };
  },
  computed: {
    // vNode
    // 主体表格
    vNodeTable: function vNodeTable() {
      var h = this.$createElement;
      var node = h("d2-table", {
        "ref": "table",
        "attrs": _objectSpread(_objectSpread({}, this.table), {}, {
          "loading": this.isTableLoading
        }),
        "on": {
          "sort-change": this.onTableSortChange
        }
      });
      return node;
    },
    // vNode
    // 搜索表单
    vNodeSearchForm: function vNodeSearchForm() {
      var h = this.$createElement;
      var node = h("el-form", {
        "attrs": _objectSpread({}, this.search.form),
        "class": "is-thin"
      }, [this.settingSearchFilteredShow.map(function (item) {
        var formItem = h("el-form-item", {
          "attrs": {
            "label": item.label,
            "prop": item.prop
          }
        }, [item.render]);
        return formItem;
      }), h("el-form-item", {
        "attrs": {
          "label": "operating"
        }
      }, [this.vNodeButtonSearchInForm, this.vNodeButtonSearchFormResetInForm])]);
      return node;
    },
    vNodeSearchForm2: function vNodeSearchForm2() {
      var h = this.$createElement;
      var node = h("el-form", {
        "attrs": _objectSpread({}, this.search.form),
        "class": "is-thin"
      }, [this.settingSearchFilteredShow.map(function (item) {
        var formItem = h("el-form-item", {
          "attrs": {
            "label": item.label,
            "prop": item.prop
          }
        }, [item.render]);
        return formItem;
      }), h("el-form-item", {
        "attrs": {
          "label": "operating"
        }
      }, [this.vNodeButtonSearchInForm, this.vNodeButtonSearchFormResetInForm, this.vNodeButtonSmsRechargeInForm]), this.settinginfoLabelFilteredShow.map(function (item) {
        var formItem = h("el-form-item", {
          "attrs": {
            "label": item.label,
            "prop": item.prop
          }
        }, [item.render]);
        return formItem;
      })]);
      return node;
    },
    // vNode
    // 搜索按钮
    // 搜索表单中的搜索按钮
    vNodeButtonSearchInForm: function vNodeButtonSearchInForm() {
      var _this = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "icon": "el-icon-search",
          "label": this.$t('search'),
          "type": "primary",
          "loading": this.isSearchButtonLoading,
          "thin": true
        },
        "on": {
          "click": function click() {
            return _this.research();
          }
        }
      });
      return node;
    },
    // vNode
    // 搜索表单中的重置按钮
    vNodeButtonSearchFormResetInForm: function vNodeButtonSearchFormResetInForm() {
      var _this2 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "icon": "el-icon-refresh",
          "label": this.$t('reset'),
          "plain": true,
          "thin": true
        },
        "on": {
          "click": function click() {
            return _this2.searchFormReset();
          }
        }
      });
      return node;
    },
    // 短信充值
    vNodeButtonSmsRechargeInForm: function vNodeButtonSmsRechargeInForm() {
      var _this3 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "icon": "el-icon-collection",
          "label": this.$t('recharge'),
          "plain": true,
          "thin": true
        },
        "on": {
          "click": function click() {
            return _this3.goSmsRecharge();
          }
        }
      });
      return node;
    },
    vNodeButtonEchart: function vNodeButtonEchart() {
      var _this4 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "icon": "el-icon-rank",
          "label": this.$t('report')
        },
        "on": {
          "click": function click() {
            return _this4.rank();
          }
        }
      });
      return node;
    },
    // vNode
    // 搜索按钮
    // 顶栏始终显示的搜索按钮
    vNodeButtonSearch: function vNodeButtonSearch() {
      var _this5 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "icon": "el-icon-refresh",
          "label": this.$t('refresh'),
          "loading": this.isSearchButtonLoading
        },
        "on": {
          "click": function click() {
            return _this5.research();
          }
        }
      });
      return node;
    },
    // vNode
    // 列过滤触发按钮
    vNodeButtonTableColumnsFilterTrigger: function vNodeButtonTableColumnsFilterTrigger() {
      var _this6 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "icon": "el-icon-set-up",
          "label": this.$t('setting')
        },
        "on": {
          "click": function click() {
            return _this6.tableColumnsFilterStart();
          }
        }
      });
      return node;
    },
    // vNode
    // 表格列设置
    vNodeTableColumnsFilter: function vNodeTableColumnsFilter() {
      var _this7 = this;

      var h = this.$createElement;
      var node = h("d2-table-columns-filter", {
        "ref": "d2-table-columns-filter",
        "attrs": _objectSpread({}, this.columnsFilter),
        "model": {
          value: _this7.table.columns,
          callback: function callback($$v) {
            _this7.$set(_this7.table, "columns", $$v);
          }
        }
      });
      return node;
    },
    // vNode
    // 新建按钮
    vNodeButtonCreate: function vNodeButtonCreate() {
      var _this8 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "type": "primary",
          "icon": "el-icon-plus",
          "label": this.$t('new')
        },
        "on": {
          "click": function click() {
            return _this8.create();
          }
        }
      });
      return node;
    },
    // vNode
    // 新建按钮
    // 新建按钮 { parent_id: 0 }
    vNodeButtonCreateWithParentId0: function vNodeButtonCreateWithParentId0() {
      var _this9 = this;

      var h = this.$createElement;
      var node = h("d2-button", {
        "attrs": {
          "type": "primary",
          "icon": "el-icon-plus",
          "label": this.$t('new')
        },
        "on": {
          "click": function click() {
            return _this9.create({
              parent_id: 0
            });
          }
        }
      });
      return node;
    },
    // vNode
    // 新建按钮
    vNodeSearchPanelAlertNoPermissionQuery: function vNodeSearchPanelAlertNoPermissionQuery() {
      var h = this.$createElement;
      var node = h("el-alert", {
        "attrs": {
          "title": "no query permission, please contact administrator",
          "type": "error",
          "closable": false,
          "center": true
        },
        "style": {
          padding: '5px 20px'
        }
      });
      return node;
    },
    // 配置项
    // 表格列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingColumns: function settingColumns() {
      return [];
    },
    // 配置项
    // 表格操作列配置
    settingActionsConfig: function settingActionsConfig() {
      return function () {
        return [];
      };
    },
    // 配置项
    // 表格操作列
    // 建议的书写顺序 [prop] -> [label] -> [align] -> [minWidth][width] -> [fixed] -> [other] -> [render][formatter] -> [if][show]
    settingActions: function settingActions() {
      var h = this.$createElement;
      var config = this.settingActionsConfig; // 赋值假数据 获得基本的设置信息

      var configStatic = config({
        row: {},
        column: {},
        $index: 0
      }); // 如果设置项数量是 0 就不显示操作列

      if (configStatic.length === 0) return []; // 宽度额外余量

      var extra = 10;
      var locale = this.$i18n.locale;
      var languagewidth = 6;

      if (locale === 'zh-chs') {
        languagewidth = 12;
      }

      var width = configStatic.length > 0 ? configStatic.reduce(function (result, item) {
        if (item.icon) result += 12;
        if (item.label) result += item.label.length * languagewidth;
        if (item.icon && item.label) result += 5;
        result += 18;
        return result;
      }, extra + 20 + 4 * (configStatic.length - 1)) : 0; // 返回计算完成的操作列

      return [{
        label: this.$t('operating'),
        align: 'center',
        width: width + 'px',
        // minWidth: 200 + 'px',
        // maxWidth: 750 + 'px',
        fixed: 'right',
        render: function render(scope) {
          return h("d2-table-actions", {
            "attrs": {
              "actions": config(scope)
            }
          });
        }
      }];
    },
    // 配置项
    // 表格搜索条件
    // 建议的书写顺序 [prop] -> [label] -> [default] -> [render] -> [if][show]
    settingSearch: function settingSearch() {
      return [];
    },
    settinginfoLabel: function settinginfoLabel() {
      return [];
    },
    // 表单设置
    // 过滤掉不显示的字段
    settingSearchFilteredShow: function settingSearchFilteredShow() {
      return this.settingSearch.filter(function (item) {
        return item.show !== false;
      });
    },
    settinginfoLabelFilteredShow: function settinginfoLabelFilteredShow() {
      return this.settinginfoLabel.filter(function (item) {
        return item.show !== false;
      });
    },
    // 搜索按钮 loading 状态
    // 正在加载原始数据 || 正在加载字典
    isSearchButtonLoading: function isSearchButtonLoading() {
      return this.status.isLoadingData || this.status.isLoadingDict;
    },
    // 表格 loading 状态
    // 正在加载原始数据 || 正在加载字典
    isTableLoading: function isTableLoading() {
      return this.status.isLoadingData || this.status.isLoadingDict;
    },
    // 搜索时发送的数据
    // 自动整合 [搜索项] [分页设置] [排序]
    searchData: function searchData() {
      return _objectSpread(_objectSpread(_objectSpread({}, this.search.form.model), this.paginationSearchData || {}), {}, {
        order_column_name: this.sort.prop,
        order_type: this.sort.type
      });
    }
  },
  watch: {
    settingColumns: 'initTableColumns',
    settingActions: 'initTableColumns'
  },
  created: function created() {
    var _this10 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _this10.initSearchForm();

              _this10.initTableColumns();

              _this10.research();

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    /**
     * @description 搜索方法 这个方法可以在外部自定义
     * @returns 数据
     */
    searchMethod: function searchMethod() {
      var method = this.$api[this.api.index];

      if (!this._.isFunction(method)) {
        this.$message.error('not find API');
        return Promise.reject(new Error('not find API'));
      }

      return method(this.searchData);
    },

    /**
     * @description 加载数据
     */
    research: function research() {
      var _this11 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var result, list, page;
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;

                if (_this11.p('query')) {
                  _context2.next = 3;
                  break;
                }

                return _context2.abrupt("return");

              case 3:
                // 表格显示无需等待字典加载完成 所以这里不需要 await
                _this11.doLoadDict(_this11.loadDict);

                _context2.next = 6;
                return _this11.doLoadData(_this11.searchMethod);

              case 6:
                result = _context2.sent;

                if (_this11._.isArray(result)) {
                  _this11.table.data = result;
                } else if (_this11._.isObject(result) && _this11._.isArray(result.list) && result.list.length > 0 && _this11._.isObject(result.page)) {
                  list = result.list, page = result.page;

                  _this11.paginationUpdate(page);

                  _this11.table.data = list;
                  /* else if (this._.isObject(result) && this._.isArray(result.list) && result.list.length === 0 && this._.isObject(result.page) && result.page.tatal_count > 0) {
                          this.table.data = []
                          this.paginationReset()
                          this.research()
                      }
                      */
                } else {
                  _this11.table.data = [];

                  _this11.paginationReset();
                }

                _context2.next = 13;
                break;

              case 10:
                _context2.prev = 10;
                _context2.t0 = _context2["catch"](0);
                console.log(_context2.t0);

              case 13:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[0, 10]]);
      }))();
    },
    rank: function rank() {
      var _this12 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                if (_this12.chart_show) {
                  _this12.chart_show = false;
                } else {
                  _this12.chart_show = true;
                }

              case 1:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },

    /**
     * @description 新建
     * @param {Object} data 新建时默认数据
     * @param {String} ref 表单组件的 ref
     */
    create: function create() {
      var data = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form';
      this.$refs[ref].create(data);
    },

    /**
     * @description 编辑
     * @param {Number} id 编辑行的 id
     * @param {String} ref 表单组件的 ref
     */
    edit: function edit(id) {
      var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form';
      this.$refs[ref].edit(id);
    },
    detail: function detail(id) {
      var ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'form2';
      this.$refs[ref].info(id);
    },

    /**
     * @description 删除
     * @param {Number} id 删除行的 id
     */
    delete: function _delete(id) {
      var _this13 = this;

      var deleteFunction = this.$api[this.api.delete];

      if (!this._.isFunction(deleteFunction)) {
        this.$message.error('not find API');
        return;
      }

      deleteFunction(id).then(function () {
        _this13.$message.success('delete success');

        _this13.research();
      }).catch(function () {});
    },
    // 清箱
    clear: function clear(id) {
      var _this14 = this;

      var clearFunction = this.$api[this.api.clear];

      if (!this._.isFunction(clearFunction)) {
        this.$message.error('not find API');
        return;
      }

      clearFunction({
        id: id
      }).then(function () {
        _this14.$message.success('clear success');

        _this14.research();
      }).catch(function () {});
    },
    // 下载二维码
    download: function download(row) {
      console.log(row);
      var id = row.id; // var url = this.$env.VUE_APP_QRCODE + row.user_mobile.substring(row.user_mobile.length - 11) + ':' + encodeURIComponent(row.user_pwd)
      // request({
      //   method: 'post',
      //   url: '/api/courier-user/qrcode',
      //   responseType: 'blob',
      //   data: { id }
      // }).then((res) => {
      //   var a = document.createElement('a')
      //   var blob = new Blob([res], { type: 'image/png' })
      //   a.download = 'qrcode.png'
      //   a.href = URL.createObjectURL(blob)
      //   a.target = '_blank'
      //   a.click()
      // })

      var a = document.createElement('a');
      a.download = 'qrcode.png';
      a.href = this.$env.VUE_APP_PIC + '/api/courier-user/qrcode' + '?id=' + id; // a.target = '_blank'

      a.click();
    },
    sync: function sync(data) {
      var _this15 = this;

      var syncFunction = this.$api[this.api.sync];

      if (!this._.isFunction(syncFunction)) {
        this.$message.error('not find API');
        return;
      }

      syncFunction(data).then(function () {
        _this15.$message.success('sync success');

        _this15.research();
      }).catch(function () {});
    },

    /**
     * @description 表格排序变化时触发
     */
    onTableSortChange: function onTableSortChange(_ref) {
      var prop = _ref.prop,
          order = _ref.order;
      this.sort.prop = prop;

      switch (order) {
        case 'ascending':
          this.sort.type = 'ASC';
          break;

        case 'descending':
          this.sort.type = 'DESC';
          break;

        default:
          this.sort.type = '';
          break;
      }

      this.research();
    },

    /**
     * @description 触发列设置面板显示
     */
    tableColumnsFilterStart: function tableColumnsFilterStart() {
      this.$refs['d2-table-columns-filter'].start();
    },

    /**
     * @description init
     * @description 根据 settingSearch 初始化搜索条件
     */
    initSearchForm: function initSearchForm() {
      var data = {};
      this.settingSearch.forEach(function (setting) {
        data[setting.prop] = setting.default;
      });
      this.$set(this.search.form, 'model', data);
    },

    /**
     * @description 重置搜索表单
     */
    searchFormReset: function searchFormReset() {
      this.initSearchForm();
      this.research();
    },

    /**
     * @description init
     * @description 合并 settingColumns 和 settingActions
     * @description 并加上 id
     */
    initTableColumns: function initTableColumns() {
      var columns = utils.fn.arrayAddUniqueId([].concat(_toConsumableArray(this.settingColumns), _toConsumableArray(this.settingActions)));
      this.table.columns = this._.cloneDeep(columns.filter(function (e) {
        return e.show !== false && e.if !== false;
      }));
      this.columnsFilter.options = this._.cloneDeep(columns.filter(function (e) {
        return e.if !== false;
      }));
    },

    /**
     * @description 请求表格数据
     * @param {Function} fn 请求函数 需要返回 Promise
     */
    doLoadData: function doLoadData() {
      var _arguments = arguments,
          _this16 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var fn, data;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                fn = _arguments.length > 0 && _arguments[0] !== undefined ? _arguments[0] : function () {};
                _this16.status.isLoadingData = true;
                _context4.prev = 2;
                _context4.next = 5;
                return fn();

              case 5:
                data = _context4.sent;
                _this16.status.isLoadingData = false;
                return _context4.abrupt("return", Promise.resolve(data));

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](2);
                _this16.status.isLoadingData = false;
                return _context4.abrupt("return", Promise.reject(_context4.t0));

              case 14:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, null, [[2, 10]]);
      }))();
    }
  }
};